<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import HorizontalContentRowHeader from '../components/HorizontalContentRowHeader.vue';
import HorizontalContentRow from '../components/HorizontalContentRow.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import router from '@/router';
import WarningIcon from '@/shared/assets/icon/warning.svg';

const retry = () => {
  router.replace({ name: 'SearchingSolshare' });
};
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <template #pageIcon>
      <WarningIcon />
    </template>
    <template #title>This SolShare requires a power cycle to proceed.</template>

    <HorizontalContentRowHeader>
      Please follow the shutdown procedure below:
    </HorizontalContentRowHeader>

    <HorizontalContentRow firstRow lastRow>
      <div class="steps-list">
        <div class="step-item">
          <span class="step-number">1.</span>
          <span class="step-text">
            Turn off all grid maintenance isolators.
          </span>
        </div>
        <div class="step-item">
          <span class="step-number">2.</span>
          <span class="step-text">
            Turn off the main AC isolator on the inverter.
          </span>
        </div>
        <div class="step-item">
          <span class="step-number">3.</span>
          <span class="step-text">
            Wait for 30 seconds before re-energizing.
          </span>
        </div>
      </div>
    </HorizontalContentRow>

    <div class="button-container">
      <ButtonPrimary block @click="retry" data-tn="retry-btn">
        Let's try again
      </ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.steps-list {
  display: flex;
  flex-direction: column;
  gap: 0.57rem;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 0.57rem;
  font-size: 1rem;
}

.step-number {
  color: @color-primary;
  font-weight: @font-weight-medium;
}

.step-text {
  line-height: 1.4;
}

.button-container {
  margin: 0 @content-side-margin;
}
</style>
